import { useQuery } from '@tanstack/react-query'

import { GetProdutoDisponivel } from '@/features/produtos/services/get-produto-disponivel'
import { produtosKeys } from '@/features/produtos/utils'

export const useProdutoDisponivel = (idExternoProduto: number) => {
  return useQuery({
    queryKey: produtosKeys.status(idExternoProduto),
    queryFn: async () => new GetProdutoDisponivel().execute(idExternoProduto).then((res) => res.data),
    enabled: false,
  })
}
